var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _g, _path10, _path11, _rect2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSzl(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2754_3801",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 23,
    height: 23
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 23,
    height: 23,
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2754_3801)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0H23V23H0V0Z",
    fill: "#3D58DB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 5.25H-0.5V5.75V17.25V17.75H0H23H23.5V17.25V5.75V5.25H23H0Z",
    fill: "#C51918",
    stroke: "#FFD018"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.13853 8.94226C5.05231 8.94226 4.98242 8.68236 4.98242 8.36176C4.98242 8.04115 5.05231 7.78125 5.13853 7.78125H17.6525C17.7387 7.78125 17.8086 8.04115 17.8086 8.36176C17.8086 8.68236 17.7387 8.94226 17.6525 8.94226H5.13853Z",
    fill: "#FFD018"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.3184 8.24386L18.0451 7.00781L19.3309 8.24386L18.0451 9.51242L17.3184 8.24386Z",
    fill: "#F7FCFF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M5.13853 12.7758C5.05231 12.7758 4.98242 12.5159 4.98242 12.1953C4.98242 11.8746 5.05231 11.6147 5.13853 11.6147H17.6525C17.7387 11.6147 17.8086 11.8746 17.8086 12.1953C17.8086 12.5159 17.7387 12.7758 17.6525 12.7758H5.13853Z",
    fill: "#FFD018"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.3184 12.0774L18.0451 10.8413L19.3309 12.0774L18.0451 13.3459L17.3184 12.0774Z",
    fill: "#F7FCFF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M3.12331 15.1625C3.00771 15.1625 2.914 14.8674 2.914 14.5034C2.914 14.1393 3.00771 13.8442 3.12331 13.8442H19.9019C20.0175 13.8442 20.1113 14.1393 20.1113 14.5034C20.1113 14.8674 20.0175 15.1625 19.9019 15.1625H3.12331Z",
    fill: "#FFD018"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.33746 11.5507C6.33746 11.5507 8.37968 5.81982 11.3006 5.81982C14.2216 5.81982 16.3325 11.5507 16.3325 11.5507C16.3325 11.5507 13.7549 17.2062 11.335 17.2062C8.91501 17.2062 6.33746 11.5507 6.33746 11.5507Z",
    fill: "#F7FCFF"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_2754_3801",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 6,
    y: 5,
    width: 11,
    height: 13
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.33746 11.5507C6.33746 11.5507 8.37968 5.81982 11.3006 5.81982C14.2216 5.81982 16.3325 11.5507 16.3325 11.5507C16.3325 11.5507 13.7549 17.2062 11.335 17.2062C8.91501 17.2062 6.33746 11.5507 6.33746 11.5507Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_2754_3801)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.4456 5.44336C11.4456 5.44336 10.7791 6.52264 11.0013 7.55181C11.2235 8.58098 11.7411 8.47227 11.7411 9.37863C11.7411 10.285 11.502 11.2093 11.7411 11.2093C11.9802 11.2093 12.063 11.8348 11.8445 12.2588C11.626 12.6828 11.4327 12.6959 11.4456 13.386C11.4586 14.0761 12.5899 14.7536 12.0419 14.7536C11.4938 14.7536 10.7715 15.4628 11.0013 15.4628C11.2311 15.4628 12.4335 16.0154 12.4335 16.7406C12.4335 17.4659 12.4335 18.0462 12.4335 18.0462H6.16064V5.44336H11.4456Z",
    fill: "#272727"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.49496 9.50977H8.18274V11.2053H8.49496V9.50977ZM9.416 9.50977H9.10378V11.2053H9.416V9.50977ZM8.64326 9.50977H8.95548V11.2053H8.64326V9.50977ZM9.87652 9.50977H9.5643V11.2053H9.87652V9.50977ZM10.0248 9.50977H10.337V11.2053H10.0248V9.50977ZM10.7976 9.50977H10.4853V11.2053H10.7976V9.50977ZM8.18274 11.9425H8.49496V13.638H8.18274V11.9425ZM9.416 11.9425H9.10378V13.638H9.416V11.9425ZM8.64326 11.9425H8.95548V13.638H8.64326V11.9425ZM9.87652 11.9425H9.5643V13.638H9.87652V11.9425ZM10.0248 11.9425H10.337V13.638H10.0248V11.9425ZM10.7976 11.9425H10.4853V13.638H10.7976V11.9425Z",
    fill: "#F7FCFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.2025 9.50977H11.8903V11.2053H12.2025V9.50977ZM13.1236 9.50977H12.8114V11.2053H13.1236V9.50977ZM12.3508 9.50977H12.6631V11.2053H12.3508V9.50977ZM13.5841 9.50977H13.2719V11.2053H13.5841V9.50977ZM13.7324 9.50977H14.0446V11.2053H13.7324V9.50977ZM14.5051 9.50977H14.1929V11.2053H14.5051V9.50977ZM11.8903 11.9425H12.2025V13.638H11.8903V11.9425ZM13.1236 11.9425H12.8114V13.638H13.1236V11.9425ZM12.3508 11.9425H12.6631V13.638H12.3508V11.9425ZM13.5841 11.9425H13.2719V13.638H13.5841V11.9425ZM13.7324 11.9425H14.0446V13.638H13.7324V11.9425ZM14.5051 11.9425H14.1929V13.638H14.5051V11.9425Z",
    fill: "#272727"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.51022 6.77713C9.07286 6.9578 8.87272 8.48712 8.9216 8.85678C8.97049 9.22643 9.11888 8.8104 9.11888 8.8104C9.11888 8.8104 9.42151 9.68737 9.45271 9.92331C9.48391 10.1593 9.64328 9.56666 9.64328 9.56666C9.64328 9.56666 10.1682 10.0488 10.2392 10.5861C10.3103 11.1233 10.4172 9.97128 10.4172 9.97128L10.5361 9.94332L10.4608 9.37445L10.6876 9.63299L10.6176 9.10396C10.6176 9.10396 10.7884 9.40153 10.7451 9.07399C10.7018 8.74645 10.6776 8.56359 10.6776 8.56359L10.6184 8.11589L10.8428 8.06313C10.8428 8.06313 9.94758 6.59646 9.51022 6.77713Z",
    fill: "#3D58DB"
  }))), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.751 13.1255C18.2967 13.2021 17.9005 14.6619 17.9005 15.0372C17.9005 15.4126 18.1008 15.0372 18.1008 15.0372C18.1008 15.0372 18.2846 15.971 18.2846 16.2105C18.2846 16.4501 18.5187 15.9034 18.5187 15.9034C18.5187 15.9034 18.9729 16.4998 18.9729 17.0453C18.9729 17.5909 19.2281 16.4811 19.2281 16.4811H19.3489V15.9034L19.5385 16.2105V15.6733C19.5385 15.6733 19.668 16.0059 19.668 15.6733C19.668 15.3408 19.668 15.1551 19.668 15.1551V14.7005H19.8959C19.8959 14.7005 19.2052 13.0488 18.751 13.1255Z",
    fill: "#3D58DB"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.0199 12.9043C4.47415 12.9809 4.87042 14.4407 4.87042 14.8161C4.87042 15.1914 4.6701 14.8161 4.6701 14.8161C4.6701 14.8161 4.48629 15.7498 4.48629 15.9893C4.48629 16.2289 4.25216 15.6822 4.25216 15.6822C4.25216 15.6822 3.79801 16.2786 3.79801 16.8241C3.79801 17.3697 3.54274 16.2599 3.54274 16.2599H3.422V15.6822L3.23235 15.9893V15.4522C3.23235 15.4522 3.10292 15.7848 3.10292 15.4522C3.10292 15.1196 3.10292 14.9339 3.10292 14.9339V14.4793H2.87501C2.87501 14.4793 3.56566 12.8276 4.0199 12.9043Z",
    fill: "#3D58DB"
  }))), /*#__PURE__*/React.createElement("rect", {
    width: 23,
    height: 23,
    rx: 11.5,
    fill: "url(#paint0_linear_2754_3801)",
    style: {
      mixBlendMode: "overlay"
    }
  }), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 22,
    height: 22,
    rx: 11,
    stroke: "black",
    strokeOpacity: 0.1
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2754_3801",
    x1: 11.5,
    y1: 0,
    x2: 11.5,
    y2: 23,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0.3
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSzl);
export default __webpack_public_path__ + "static/media/SZL.df564ee8afdad14cbb139ae1fb562d68.svg";
export { ForwardRef as ReactComponent };